import RadioGroup from "Components/RadioButtons/RadioGroup";
import styles from "Styles/CompanySize.module.css";
import inputStyles from "Styles/Inputs.module.css";
import { useForm, FormProvider } from "react-hook-form";
import { useState, useEffect } from "react";
import { Button } from "Components/Button";
import KeyboardHint from "Components/KeyboardHint";
import ErrorMessage from "Components/ErrorMessage";
import { companySizeData } from "Data";
import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";

export default function CompanySizeFormContent({
  submitCB = () => {},
  formHeading = "單選題",
  companySize = null,
}) {
  const [selectedValue, setSelectedValue] = useState(companySize);

  const methods = useForm({
    defaultValues: {
      radio: companySize || null,
    },
  });

  const {
    formState: { errors },
    handleSubmit,
    reset,
  } = methods;

  useEffect(() => {
    if (companySize) {
      reset({
        radio: companySize,
      });
      setSelectedValue(companySize);
    }
  }, [companySize, reset]);

  const handleChange = (value) => {
    setSelectedValue(value);
  };

  const onSubmit = (data, e) => {
    e.preventDefault();
    submitCB(selectedValue);
  };

  return (
    <InfoContentMotionWrapper>
      <div className={styles.content}>
        <fieldset className={inputStyles.fieldset}>
          {formHeading && (
            <legend className={inputStyles.legend}>{formHeading}</legend>
          )}

          <FormProvider {...methods}>
            <form
              className={inputStyles.form}
              onSubmit={handleSubmit(onSubmit)}
            >
              <RadioGroup
                radioData={companySizeData}
                handleChange={handleChange}
                selectedValue={selectedValue}
                name="companySize"
                variant="pill"
              />
              {errors?.radio && <ErrorMessage text="請選擇公司規模" />}
              <div
                style={{ display: "flex", alignItems: "end", gap: "0.75rem" }}
              >
                <Button
                  disabled={!selectedValue}
                  marginTop
                  type="action"
                  submit
                >
                  OK
                </Button>
                <KeyboardHint />
              </div>
            </form>
          </FormProvider>
        </fieldset>
      </div>
    </InfoContentMotionWrapper>
  );
}
